import { getDeleteDepartmentsMutationOptions } from '@vlabs/api/artemy/client';
import type { DepartmentId } from '@vlabs/api/artemy/model';
import { queryClient } from '@vlabs/api/queryClient';
import { toast } from 'react-toastify';

import { checkDeleteDepartmentPossibility } from '@vlabs/monokit/entities/departments';

import { confirmDeleteDepartments } from './confirmDeleteDepartments';
import { deleteDepartmentTranslation as t } from './i18n';

interface DeleteDepartmentsParams {
  departmentIds: [DepartmentId];
  onDeleteDepartments?: () => void;
}

export async function deleteDepartments({
  departmentIds,
  onDeleteDepartments,
}: DeleteDepartmentsParams): Promise<void> {
  if (!departmentIds.length) return;

  const confirmation = await confirmDeleteDepartments({
    departmentIds,
  });

  if (confirmation === 'cancelled') return;

  const [departmentId] = departmentIds;

  const deletionPossibility = await checkDeleteDepartmentPossibility({
    departmentId,
  });

  if (deletionPossibility === 'impossible') return;

  try {
    await queryClient.mutateAsync(
      getDeleteDepartmentsMutationOptions(queryClient),
      {
        data: {
          departments_ids: departmentIds,
        },
      },
    );

    toast.success(t('toast_success'));
    onDeleteDepartments?.();
  } catch {
    toast.error(t('toast_error'));
  }
}
